module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/costume_type_kimono@2x-7399433b4951d487c7476bfa5d518ecf.webp";